import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import React from "react";
import { CorrespondentList } from "./correspondent/list/CorrespondentList";
import { CorrespondentDetail } from "./correspondent/detail/CorrespondentDetail";
import { ContactList } from "./contact/feature/ContactList";
import { ContactDetail } from "./contact/feature/ContactDetail";
import { ProjectList } from "./project/features/ProjectList";
import { ProjectDetail } from "./project/features/ProjectDetail";
import { TierList } from "./tier/feature/TierList";
import { BeforeApprovalTab } from "./correspondent/detail/features/BeforeApprovalTab";

export default function Customer() {
  const { key } = useLocation();

  return (
    <Routes>
      <Route
        key={key}
        path={"correspondent/list"}
        element={<CorrespondentList />}
      />
      <Route
        key={key}
        path={"correspondent/detail/:id"}
        element={<CorrespondentDetail />}
      />
      <Route
        key={key}
        path={"correspondent/beforeApproval/:id"}
        element={<BeforeApprovalTab />}
      />
      <Route
        key={key}
        path={"correspondent/create"}
        element={<CorrespondentDetail isCreate={true} />}
      />
      <Route key={key} path={"contact/list"} element={<ContactList />} />
      <Route
        key={key}
        path={"contact/detail/:id"}
        element={<ContactDetail isCreate={false} />}
      />
      <Route
        key={key}
        path={"contact/create"}
        element={<ContactDetail isCreate={true} />}
      />
      <Route key={key} path={"project/list"} element={<ProjectList />} />
      <Route
        key={key}
        path={"project/detail/:id"}
        element={<ProjectDetail />}
      />
      <Route
        key={key}
        path={"project/create"}
        element={<ProjectDetail isCreate={true} />}
      />
      <Route key={key} path={"tier/list"} element={<TierList />} />
      <Route
        key={key}
        path={"*"}
        element={<Navigate to={"/not_found"} />}
      />
    </Routes>
  );
}
